import { Modal, Table, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

const columnsFor = (periodLabel) => [
  { title: periodLabel, dataIndex: 'label', key: 'label' },
  { title: 'Raw', dataIndex: 'rawCount', key: 'rawCount', align: 'center' },
  {
    title: 'Genuine',
    dataIndex: 'excusedCount',
    key: 'excusedCount',
    align: 'center',
  },
  {
    title: 'Effective',
    dataIndex: 'effectiveCount',
    key: 'effectiveCount',
    align: 'center',
  },
];

/**
 * PeriodBreakdownModal drills a Quarter-tab or Year-tab count down into its
 * month-wise or quarter-wise components, sourced from the teamAttendance
 * row's monthlyBreakdown / quarterlyBreakdown fields.
 */
function PeriodBreakdownModal({
  open,
  loading,
  employeeName,
  behaviourTitle,
  periodType,
  rows,
  onCancel,
}) {
  const periodLabel = periodType === 'MONTH' ? 'Month' : 'Quarter';
  const titleParts = [employeeName, behaviourTitle].filter(Boolean);

  return (
    <Modal
      rootClassName="period-breakdown-modal"
      title={
        titleParts.length
          ? `${titleParts.join(' — ')} (${periodLabel}-wise)`
          : `${periodLabel}-wise Breakdown`
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Table
        size="small"
        bordered
        pagination={false}
        loading={loading}
        columns={columnsFor(periodLabel)}
        dataSource={rows || []}
        rowKey="key"
        locale={{
          emptyText: (
            <Text type="secondary">
              {`No ${periodLabel.toLowerCase()}-wise data available`}
            </Text>
          ),
        }}
      />
    </Modal>
  );
}

export default PeriodBreakdownModal;
